// extracted by mini-css-extract-plugin
export default {"article":"About_article__JmwAg","swiperWrapper":"About_swiperWrapper__fIFRH","imgBlock":"About_imgBlock__lemZf","img":"About_img__Qm4nt"};